(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["club-hero-member"] && !Shopify.designMode) return;
  try {
    
  /*
   * Upgrades the hero to the customer's club tier once the shared loyalty layer
   * resolves. The balance and euro value are filled by <loyalty-data>; this only
   * handles the level-driven theming (gradient via data-level) and the per-level
   * eyebrow / title copy. Stays on the rendered 'member' default until the tier
   * (Yotpo vipTierName) is present on the payload. See BRD-470.
   */
  class ClubHeroMember extends HTMLElement {
    connectedCallback() {
      this.addEventListener('loyalty:loaded', this.applyTier.bind(this));
    }

    applyTier(event) {
      const detail = event.detail || {};
      // The tier key is pending on the /customer DTO; accept either name.
      const level = this.mapTier(detail.tier || detail.vipTierName);
      if (!level) return;

      this.dataset.level = level;

      const eyebrow = this.querySelector('[data-hero-eyebrow]');
      const title = this.querySelector('[data-hero-title]');
      const capitalized = level.charAt(0).toUpperCase() + level.slice(1);

      if (eyebrow && this.dataset['eyebrow' + capitalized]) {
        eyebrow.textContent = this.dataset['eyebrow' + capitalized];
      }
      if (title && this.dataset['title' + capitalized]) {
        title.textContent = this.dataset['title' + capitalized];
      }
    }

    mapTier(tier) {
      if (!tier) return null;
      const value = String(tier).toLowerCase();
      if (value.includes('legend')) return 'legend';
      if (value.includes('star')) return 'star';
      if (value.includes('member')) return 'member';
      return null;
    }
  }

  if (!customElements.get('club-hero-member')) {
    customElements.define('club-hero-member', ClubHeroMember);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["club-member-perks"] && !Shopify.designMode) return;
  try {
    
  /*
   * Arranges the perk cards into the active / locked rows from the customer's
   * club tier. Every perk is server-rendered in both rows with both copies;
   * this toggles which one is shown. The server default is Member (rank 1) and
   * we only re-toggle when a higher tier resolves. Mobile pager dots are built
   * per row from the visible cards. Tier (vipTierName) is pending; until then
   * the rendered Member arrangement stands. See BRD-470.
   */
  class ClubMemberPerks extends HTMLElement {
    connectedCallback() {
      this.currentRank = 1;
      this.lockedRow = this.querySelector('[data-perks-locked-row]');
      this.observers = new Map();
      this.initPagers();
      this.addEventListener('loyalty:loaded', this.onLoaded.bind(this));
    }

    onLoaded(event) {
      const detail = event.detail || {};
      const rank = this.mapRank(detail.tier || detail.vipTierName);
      if (!rank || rank === this.currentRank) return;
      this.currentRank = rank;
      this.applyRank(rank);
    }

    applyRank(rank) {
      this.querySelectorAll('.club-member-perks__card--active').forEach((card) => {
        card.hidden = Number(card.dataset.perkRank) > rank;
      });
      this.querySelectorAll('.club-member-perks__card--locked').forEach((card) => {
        card.hidden = Number(card.dataset.perkRank) <= rank;
      });
      if (this.lockedRow) this.lockedRow.hidden = rank >= 3;
      this.initPagers();
    }

    initPagers() {
      this.querySelectorAll('.club-member-perks__slider').forEach((slider) => this.initPager(slider));
    }

    initPager(slider) {
      const scroller = slider.querySelector('.club-member-perks__cards');
      if (!scroller) return;

      const cards = Array.from(slider.querySelectorAll('.club-member-perks__card')).filter((card) => !card.hidden);
      let pager = slider.querySelector('.club-member-perks__pager');

      const existing = this.observers.get(slider);
      if (existing) {
        existing.disconnect();
        this.observers.delete(slider);
      }

      if (cards.length < 2) {
        if (pager) pager.remove();
        return;
      }

      if (!pager) {
        pager = document.createElement('ol');
        pager.className = 'club-member-perks__pager';
        pager.setAttribute('aria-hidden', 'true');
        slider.appendChild(pager);
      }

      pager.replaceChildren(
        ...cards.map((_, index) => {
          const dot = document.createElement('li');
          dot.className = 'club-member-perks__pager-dot';
          if (index === 0) dot.classList.add('club-member-perks__pager-dot--active');
          return dot;
        })
      );

      const dots = pager.querySelectorAll('.club-member-perks__pager-dot');
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const index = cards.indexOf(entry.target);
            dots.forEach((dot, i) => dot.classList.toggle('club-member-perks__pager-dot--active', i === index));
          });
        },
        { root: scroller, threshold: 0.6 }
      );

      cards.forEach((card) => observer.observe(card));
      this.observers.set(slider, observer);
    }

    mapRank(tier) {
      if (!tier) return null;
      const value = String(tier).toLowerCase();
      if (value.includes('legend')) return 3;
      if (value.includes('star')) return 2;
      if (value.includes('member')) return 1;
      return null;
    }
  }

  if (!customElements.get('club-member-perks')) {
    customElements.define('club-member-perks', ClubMemberPerks);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["club-multicolumn"] && !Shopify.designMode) return;
  try {
    
  class ClubMulticolumnSlider extends HTMLElement {
    connectedCallback() {
      const scroller = this.querySelector('.club-multicolumn__cards');
      const cards = this.querySelectorAll('.club-multicolumn__card');
      const dots = this.querySelectorAll('.club-multicolumn__pager-dot');

      if (!scroller || cards.length < 2 || dots.length !== cards.length) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const index = Array.from(cards).indexOf(entry.target);
            dots.forEach((dot, i) => {
              dot.classList.toggle('club-multicolumn__pager-dot--active', i === index);
            });
          });
        },
        { root: scroller, threshold: 0.6 }
      );

      cards.forEach((card) => observer.observe(card));
    }
  }

  if (!customElements.get('club-multicolumn-slider')) {
    customElements.define('club-multicolumn-slider', ClubMulticolumnSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["club-referral"] && !Shopify.designMode) return;
  try {
    
  const CLUB_REFERRAL_CODE_ENDPOINT = '/apps/web/loyalty/referral-code';
  const CLUB_REFERRAL_LINK_ENDPOINT = '/apps/web/loyalty/referral-link';
  const CLUB_REFERRAL_STATUS_MS = 2500;

  /**
   * Shows the customer's referral code and copies its share link.
   *
   * The code comes from GET /apps/web/loyalty/referral-code, which answers
   * { code, codeCreatedAt, shareUrl } inside the proxy's { statusCode, data } envelope.
   * All three fields are null while the referral programme is closed.
   *
   * Only a closed programme falls back to the legacy per-customer referral link: a 200
   * with no code, or a 404 while the route is not deployed. Any other failure (5xx,
   * timeout, network error, unreadable body) hides the whole CTA, so a slow code call
   * never hands out the retired programme's link once the new one is open.
   */
  class ClubReferralCta extends HTMLElement {
    async connectedCallback() {
      this.button = this.querySelector('.club-referral__cta');
      this.codeBlock = this.querySelector('[data-referral-code-block]');
      this.codeValue = this.querySelector('[data-referral-code]');
      this.status = this.querySelector('[data-referral-status]');
      this.linkBlock = this.querySelector('[data-referral-link-block]');
      this.linkField = this.querySelector('[data-referral-link-field]');

      if (!this.button) return;

      this.button.addEventListener('click', this.handleClick.bind(this));

      const referral = await this.loadReferral();
      if (!referral) return;

      this.link = referral.link;

      if (referral.code && this.codeBlock && this.codeValue) {
        this.codeValue.textContent = referral.code;
        this.codeBlock.hidden = false;
      }

      this.hidden = false;
    }

    /**
     * Both requests start together so the legacy fallback never waits for the code call.
     *
     * @returns {Promise<{ code: string | null, link: string } | null>}
     */
    async loadReferral() {
      const codeRequest = this.fetchJson(CLUB_REFERRAL_CODE_ENDPOINT);
      const legacyRequest = this.fetchJson(CLUB_REFERRAL_LINK_ENDPOINT);

      const codeResponse = await codeRequest;
      const payload = codeResponse.data;
      const code = payload && payload.code;
      const shareUrl = payload && payload.shareUrl;
      if (clubReferralIsNonEmptyString(code) && clubReferralIsNonEmptyString(shareUrl)) {
        // Build the link on the domain the customer is browsing. The backend
        // only knows the *.myshopify.com host, whose redirect to the public
        // domain can drop the discount cookie before the friend lands.
        const link = `${window.location.origin}/discount/${encodeURIComponent(code)}?redirect=/`;
        return { code, link };
      }

      const programmeClosed =
        codeResponse.status === 404 ||
        (codeResponse.ok && payload && payload.code == null && payload.shareUrl == null);
      if (!programmeClosed) return null;

      const legacy = (await legacyRequest).data;
      const link = legacy && legacy.link;
      return clubReferralIsNonEmptyString(link) ? { code: null, link } : null;
    }

    /**
     * Never rejects. `data` is the unwrapped payload, or null when the body is missing or unreadable.
     *
     * @returns {Promise<{ ok: boolean, status: number, data: any }>}
     */
    async fetchJson(url) {
      try {
        const response = await fetch(url, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        });
        if (!response.ok) return { ok: false, status: response.status, data: null };
        const body = await response.json();
        // The proxy wraps every payload in a { statusCode, data } envelope.
        const data = body && typeof body === 'object' && 'data' in body ? body.data : body;
        return { ok: true, status: response.status, data: data && typeof data === 'object' ? data : null };
      } catch (error) {
        return { ok: false, status: 0, data: null };
      }
    }

    async handleClick() {
      if (!this.link) return;

      if (await this.copy(this.link)) {
        this.announce(this.dataset.confirmationLabel, { persist: false });
        return;
      }

      // Every copy method failed, for example in an in-app browser. Show the link so it can be copied by hand.
      this.announce(this.dataset.errorLabel, { persist: true });
      this.showLinkField();
    }

    /**
     * Tries the async Clipboard API, then the selection-based copy that older and in-app browsers still honour.
     *
     * @returns {Promise<boolean>}
     */
    async copy(text) {
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(text);
          return true;
        }
      } catch (error) {
        console.warn('Could not copy referral link with the Clipboard API.', error);
      }

      return this.copyWithSelection(text);
    }

    copyWithSelection(text) {
      const field = document.createElement('textarea');
      field.value = text;
      field.setAttribute('readonly', '');
      field.setAttribute('aria-hidden', 'true');
      field.style.position = 'fixed';
      field.style.top = '0';
      field.style.left = '0';
      field.style.opacity = '0';
      document.body.appendChild(field);

      let copied = false;
      try {
        field.select();
        field.setSelectionRange(0, text.length);
        copied = document.execCommand('copy');
      } catch (error) {
        copied = false;
      } finally {
        field.remove();
        this.button.focus();
      }

      return copied;
    }

    showLinkField() {
      if (!this.linkBlock || !this.linkField) return;

      this.linkField.value = this.link;
      this.linkBlock.hidden = false;
      this.linkField.focus();
      this.linkField.select();
    }

    /**
     * Clears the live region before writing so the same message is announced again on a repeat click.
     */
    announce(message, { persist }) {
      if (!this.status || !message) return;

      clearTimeout(this.statusTimer);
      this.status.textContent = '';

      requestAnimationFrame(() => {
        this.status.textContent = message;
        if (persist) return;

        this.statusTimer = setTimeout(() => {
          this.status.textContent = '';
        }, CLUB_REFERRAL_STATUS_MS);
      });
    }
  }

  function clubReferralIsNonEmptyString(value) {
    return typeof value === 'string' && value.length > 0;
  }

  if (!customElements.get('club-referral-cta')) {
    customElements.define('club-referral-cta', ClubReferralCta);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-alternate"]) return;
  try {
    
  const section = document.querySelector('.shopify-section--footer-alternate');
  if (section) {
    const firstAccordion = section.querySelector('accordion-custom details');
    if (firstAccordion) {
      firstAccordion.open = true;
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-alternate"]) return;
  try {
    
class NavDrawer extends HTMLElement {
  static DESKTOP_BP = 990;

  /** @type {AbortController} */
  #controller = new AbortController();

  connectedCallback() {
    this.dialog = this.closest('dialog');
    this.dialogComponent = this.closest('dialog-component');
    this.header = this.dialog.querySelector('.nav-drawer__header');
    this.headerLabel = this.header.querySelector('.nav-drawer__header-label');
    this.defaultLabel = this.headerLabel.textContent;
    this.headerAction = this.header.querySelector('.nav-drawer__header-action');

    this.level1List = this.querySelector('.nav-drawer__level-1');
    this.level1Items = [...this.level1List.querySelectorAll(':scope > .nav-drawer__item')];
    this.defaultL1 = this.level1Items.find(item => item.hasAttribute('data-has-children'));

    // Desktop panels container (sibling of nav-drawer, direct dialog child)
    this.desktopPanels = this.dialog.querySelector('.nav-drawer__desktop-panels');

    // Mobile navigation stack
    this.mobileStack = [];

    this.#setupHeaderButton();
    this.#setupDesktop();
    this.#setupMobile();
    this.#listenForDialogClose();
    this.#listenForBreakpointChange();

    // Set desktop default
    if (this.defaultL1) this.#setActiveL1Desktop(this.defaultL1);
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  get isDesktop() {
    return window.matchMedia(`(min-width: ${NavDrawer.DESKTOP_BP}px)`).matches;
  }

  // ── Header button (close or back) ──────────────────────────────────

  #setupHeaderButton() {
    const { signal } = this.#controller;
    this.headerAction.addEventListener('click', () => {
      if (!this.isDesktop && this.mobileStack.length > 0) {
        this.#slideOut();
      } else {
        this.dialogComponent?.closeDialog();
      }
    }, { signal });
  }

  // ── Dialog close → full reset ──────────────────────────────────────

  #listenForDialogClose() {
    const { signal } = this.#controller;
    this.dialogComponent?.addEventListener('dialog-close', () => this.#reset(), { signal });
  }

  #listenForBreakpointChange() {
    const { signal } = this.#controller;
    const mql = window.matchMedia(`(min-width: ${NavDrawer.DESKTOP_BP}px)`);
    mql.addEventListener('change', () => this.#reset(), { signal });
  }

  #reset() {
    // Clear mobile stack
    while (this.mobileStack.length > 0) {
      const entry = this.mobileStack.pop();
      entry.panel.classList.remove('is-active');
      if (entry.scrollParent) entry.scrollParent.style.overflow = '';
    }
    this.headerLabel.textContent = this.defaultLabel;
    this.header.setAttribute('data-mode', 'close');

    // Reset desktop to default (also clears L2 state)
    if (this.defaultL1) this.#setActiveL1Desktop(this.defaultL1);
  }

  // ── Desktop: hover-driven via desktop panels ───────────────────────

  #setupDesktop() {
    if (!this.desktopPanels) return;

    const { signal } = this.#controller;

    // L1 hover → only react to non-orphan items (those with data-l1-index)
    for (const item of this.level1Items) {
      item.addEventListener('mouseenter', () => {
        if (!this.isDesktop) return;
        if (!item.hasAttribute('data-l1-index')) return;
        this.#setActiveL1Desktop(item);
      }, { signal });
    }

    // L2 hover inside desktop panels → swap right column cards (sticky)
    const allPanels = this.desktopPanels.querySelectorAll('.nav-drawer__desktop-panel');
    for (const panel of allPanels) {
      const l2Items = panel.querySelectorAll('.nav-drawer__level-2 > .nav-drawer__item[data-has-children]');
      for (const l2Item of l2Items) {
        l2Item.addEventListener('mouseenter', () => {
          if (!this.isDesktop) return;
          this.#setActiveL2Desktop(l2Item, panel);
        }, { signal });
      }
    }
  }

  #setActiveL1Desktop(activeItem) {
    if (!this.desktopPanels) return;
    const l1Index = activeItem.getAttribute('data-l1-index');

    // Track current active L1
    this.activeL1Desktop = activeItem;

    // Update opacity on L1 items — active item is full opacity
    for (const item of this.level1Items) {
      item.toggleAttribute('data-active', item === activeItem);
    }

    // Show matching desktop panel, hide others
    const panels = this.desktopPanels.querySelectorAll('.nav-drawer__desktop-panel');
    for (const panel of panels) {
      panel.toggleAttribute('data-visible', panel.getAttribute('data-for-l1') === l1Index);
    }

    // Reset L2 state for the newly shown panel (back to L1 default cards)
    const activePanel = this.desktopPanels.querySelector(`.nav-drawer__desktop-panel[data-for-l1="${l1Index}"]`);
    if (activePanel) this.#clearActiveL2Desktop(activePanel);
  }

  #setActiveL2Desktop(activeL2Item, panel) {
    const l2Index = activeL2Item.getAttribute('data-l2-index');
    const cardsContainer = panel.querySelector('.nav-drawer__desktop-cards');
    if (!cardsContainer) return;

    // Remove active from L1 — heart moves to L2
    if (this.activeL1Desktop) {
      this.activeL1Desktop.removeAttribute('data-active');
    }

    // Update L2 active states
    const l2Items = panel.querySelectorAll('.nav-drawer__level-2 > .nav-drawer__item');
    for (const item of l2Items) {
      item.toggleAttribute('data-active', item === activeL2Item);
    }

    // Show matching L2 card set, hide others
    const l2CardSets = cardsContainer.querySelectorAll('[data-for-l2]');
    for (const set of l2CardSets) {
      set.toggleAttribute('data-visible', set.getAttribute('data-for-l2') === l2Index);
    }

    // Hide L1 default cards
    const l1Cards = cardsContainer.querySelector('[data-l1-cards]');
    if (l1Cards) l1Cards.setAttribute('data-hidden', '');
  }

  #clearActiveL2Desktop(panel) {
    const l2Items = panel.querySelectorAll('.nav-drawer__level-2 > .nav-drawer__item');
    for (const item of l2Items) {
      item.removeAttribute('data-active');
    }

    const cardsContainer = panel.querySelector('.nav-drawer__desktop-cards');
    if (!cardsContainer) return;

    const l2CardSets = cardsContainer.querySelectorAll('[data-for-l2]');
    for (const set of l2CardSets) {
      set.removeAttribute('data-visible');
    }

    const l1Cards = cardsContainer.querySelector('[data-l1-cards]');
    if (l1Cards) l1Cards.removeAttribute('data-hidden');
  }

  // ── Mobile: click-driven slide panels ──────────────────────────────

  #setupMobile() {
    const { signal } = this.#controller;
    this.addEventListener('click', (e) => {
      if (this.isDesktop) return;

      const link = e.target.closest('.nav-drawer__link');
      if (!link) return;

      const item = link.closest('.nav-drawer__item');
      if (!item?.hasAttribute('data-has-children')) return;

      // Ignore clicks inside desktop panels
      if (item.closest('.nav-drawer__desktop-panels')) return;

      e.preventDefault();

      const l2Panel = item.querySelector(':scope > .nav-drawer__level-2-panel');
      const l3Panel = item.querySelector(':scope > .nav-drawer__level-3-panel');
      const title = link.querySelector('.nav-drawer__link-text')?.textContent || '';

      if (l2Panel) this.#slideIn(l2Panel, title);
      else if (l3Panel) this.#slideIn(l3Panel, title);
    }, { signal });
  }

  #slideIn(panel, title) {
    // Lock scroll on the parent scrollable container
    const scrollParent = panel.parentElement.closest('.nav-drawer__content, .nav-drawer__level-2-panel');
    this.mobileStack.push({
      panel,
      previousLabel: this.headerLabel.textContent,
      scrollParent,
    });
    if (scrollParent) scrollParent.style.overflow = 'hidden';

    panel.classList.add('is-active');
    this.headerLabel.textContent = title;
    this.header.setAttribute('data-mode', 'back');
  }

  #slideOut() {
    const entry = this.mobileStack.pop();
    if (!entry) return;

    entry.panel.classList.remove('is-active');
    if (entry.scrollParent) entry.scrollParent.style.overflow = '';

    if (this.mobileStack.length === 0) {
      this.headerLabel.textContent = this.defaultLabel;
      this.header.setAttribute('data-mode', 'close');
    } else {
      this.headerLabel.textContent = this.mobileStack[this.mobileStack.length - 1].previousLabel;
    }
  }
}

if (!customElements.get('nav-drawer')) {
  customElements.define('nav-drawer', NavDrawer);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-alternate"]) return;
  try {
    
  const toggle = document.querySelector('.collection-alternate__view-toggle');
  if (toggle) {
    const grid = document.querySelector('.collection-alternate__grid');
    toggle.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-view-columns]');
      if (!btn || !grid) return;
      const columns = btn.dataset.viewColumns;
      grid.dataset.view = columns;
      toggle.querySelectorAll('.collection-alternate__view-btn').forEach((b) => {
        b.classList.toggle('collection-alternate__view-btn--active', b === btn);
      });
    });
  }

  // Shopify's storefront filtering matches a filter on variant or product existence, not
  // stock, so its counts include sold-out products. Pairing every active filter with
  // filter.v.availability=1 restricts the match to in-stock products (filter.v.* params
  // combine on the same variant), so the grid, the counts and the drawer button only
  // count what can be bought. Patching the prototype at the URL-serialization choke point
  // covers checkbox changes, keyboard, per-group clearFilter (which fires no change event)
  // and hover prefetch; updateFiltersByURL covers the category pills, the view-all CTA and
  // clear all, which push a ready-made URL. Both survive section-renderer swaps. The
  // availability facet is hidden from the drawer, so the delete branch cannot fight a user
  // choice - revisit if that facet is ever exposed.
  const FILTER_PARAM_PREFIX = 'filter.';
  const AVAILABILITY_PARAM = 'filter.v.availability';

  /** @param {URLSearchParams} params */
  const hasActiveFilter = (params) =>
    [...params.keys()].some((key) => key.startsWith(FILTER_PARAM_PREFIX) && key !== AVAILABILITY_PARAM);

  /** @param {URLSearchParams} params */
  const pairAvailability = (params) => {
    if (hasActiveFilter(params)) {
      params.set(AVAILABILITY_PARAM, '1');
    } else {
      params.delete(AVAILABILITY_PARAM);
    }
    return params;
  };

  // With no active filter the URL carries no availability pairing, so the drawer's values, the
  // category pills and their counts still include sold-out products. Both are swapped for the
  // ones Shopify renders with filter.v.availability=1, which leaves out the values, the pills
  // and the sections with no stock, so a click can never lead to an empty grid. The grid and
  // the results button keep counting every product, as they do without a filter. Until the
  // swap lands, the section carries data-in-stock-pending (rendered by Liquid when no filter
  // is active), which hides the values and the pills that may go.
  const DRAWER_CONTENT_SELECTOR = '.collection-alternate__drawer-content';
  const QUICK_FILTERS_LIST_SELECTOR = '.collection-alternate__filters-list';
  const PENDING_ATTRIBUTE = 'data-in-stock-pending';

  /** @param {string} elementId */
  const sectionRoot = (elementId) => document.getElementById(elementId);

  /** @param {string} elementId */
  const clearPending = (elementId) => {
    sectionRoot(elementId)?.querySelector(`[${PENDING_ATTRIBUTE}]`)?.removeAttribute(PENDING_ATTRIBUTE);
  };

  /**
   * Starts the in-stock render for the current URL, or resolves null when a filter is active.
   * @param {string} sectionId
   * @returns {Promise<string | null>}
   */
  const fetchInStockHTML = async (sectionId) => {
    const url = new URL(window.location.href);
    if (hasActiveFilter(url.searchParams)) return null;
    url.searchParams.set(AVAILABILITY_PARAM, '1');
    const { sectionRenderer } = await import('@theme/section-renderer');
    return sectionRenderer.getSectionHTML(sectionId, true, url);
  };

  /**
   * Morphs the drawer values and the category pills from the in-stock render.
   * @param {string} sectionId
   * @param {string} search - The URL search the in-stock render was started for
   * @param {Promise<string | null>} pendingHTML
   */
  const showInStockValues = async (sectionId, search, pendingHTML) => {
    const [{ buildSectionSelector }, { morph, MORPH_OPTIONS }] = await Promise.all([
      import('@theme/section-renderer'),
      import('@theme/morph'),
    ]);
    const elementId = buildSectionSelector(sectionId);
    try {
      const html = await pendingHTML;
      // A filter applied meanwhile re-renders the section with paired counts already.
      if (html === null || window.location.search !== search) return;
      const root = sectionRoot(elementId);
      const inStockRoot = new DOMParser().parseFromString(html, 'text/html').getElementById(elementId);
      if (!root || !inStockRoot) return;

      // The in-stock render's links carry the pairing, the pills' own click handler pairs again.
      for (const link of inStockRoot.querySelectorAll(`${QUICK_FILTERS_LIST_SELECTOR} a[href]`)) {
        const href = new URL(link.getAttribute('href') ?? '', window.location.href);
        pairAvailability(href.searchParams);
        link.setAttribute('href', href.pathname + href.search);
      }

      // A price being typed is committed on change only, the morph would reset it.
      const active = document.activeElement;
      const typing =
        active instanceof HTMLInputElement && active.id && active.closest(DRAWER_CONTENT_SELECTOR) ? active : null;
      const typed = typing?.value;

      const currentLists = root.querySelectorAll(QUICK_FILTERS_LIST_SELECTOR);
      const inStockLists = inStockRoot.querySelectorAll(QUICK_FILTERS_LIST_SELECTOR);
      currentLists.forEach((list, index) => {
        if (inStockLists[index]) morph(list, inStockLists[index], MORPH_OPTIONS);
      });
      const drawer = root.querySelector(DRAWER_CONTENT_SELECTOR);
      const inStockDrawer = inStockRoot.querySelector(DRAWER_CONTENT_SELECTOR);
      if (drawer && inStockDrawer) morph(drawer, inStockDrawer, MORPH_OPTIONS);

      if (typing && typed !== undefined) {
        const input = document.getElementById(typing.id);
        if (input instanceof HTMLInputElement) {
          input.value = typed;
          if (document.activeElement !== input) input.focus();
        }
      }
    } catch {
      // The drawer and the pills keep the values they were rendered with; filtering still works.
    } finally {
      if (window.location.search === search) clearPending(elementId);
    }
  };

  /**
   * Whether the section has anything the in-stock render can change: a list filter in the
   * drawer or a category pill.
   * @param {string} elementId
   */
  const hasInStockTargets = (elementId) =>
    Boolean(
      sectionRoot(elementId)?.querySelector(
        `${DRAWER_CONTENT_SELECTOR} .facets__inputs-list, ${QUICK_FILTERS_LIST_SELECTOR} a[href*="filter."]`
      )
    );

  customElements.whenDefined('facets-form-component').then(() => {
    const FacetsForm = customElements.get('facets-form-component');
    const originalCreate = FacetsForm.prototype.createURLParameters;
    const originalByURL = FacetsForm.prototype.updateFiltersByURL;
    if (typeof originalCreate !== 'function' || FacetsForm.availabilityPairingPatched) return;
    FacetsForm.availabilityPairingPatched = true;

    FacetsForm.prototype.createURLParameters = function (formData) {
      return pairAvailability(originalCreate.call(this, formData));
    };

    if (typeof originalByURL === 'function') {
      FacetsForm.prototype.updateFiltersByURL = function (href) {
        const url = new URL(href, window.location.href);
        pairAvailability(url.searchParams);
        return originalByURL.call(this, url.toString());
      };
    }

    const sectionId = document.querySelector('facets-form-component')?.getAttribute('section-id');
    if (!sectionId) return;

    import('@theme/section-renderer').then(({ sectionRenderer, normalizeSectionId, buildSectionSelector }) => {
      const elementId = buildSectionSelector(sectionId);

      // Every re-render of this section (a filter cleared, clear all, back to the page) can land
      // on the unpaired URL. The in-stock render starts alongside it, so the swap follows the
      // section render instead of waiting for it.
      if (!sectionRenderer.inStockDrawerPatched) {
        sectionRenderer.inStockDrawerPatched = true;
        const originalRender = sectionRenderer.renderSection;
        sectionRenderer.renderSection = async function (id, options) {
          if (normalizeSectionId(id) !== sectionId) return originalRender.call(this, id, options);
          const search = window.location.search;
          const inStockHTML = fetchInStockHTML(sectionId);
          // Handled by showInStockValues; this keeps an early rejection from going unhandled.
          inStockHTML.catch(() => {});
          const html = await originalRender.call(this, id, options);
          if (hasInStockTargets(elementId)) {
            showInStockValues(sectionId, search, inStockHTML);
          } else if (window.location.search === search) {
            clearPending(elementId);
          }
          return html;
        };
      }

      // Direct entries (shared links, bookmarks) can carry a filter without the availability
      // pairing, or the pairing without a filter - fix the URL in place and re-render the section.
      const url = new URL(window.location.href);
      const before = url.searchParams.toString();
      pairAvailability(url.searchParams);
      if (url.searchParams.toString() !== before) {
        history.replaceState(history.state, '', url.toString());
        sectionRenderer.renderSection(sectionId);
      } else if (hasInStockTargets(elementId)) {
        showInStockValues(sectionId, window.location.search, fetchInStockHTML(sectionId));
      } else {
        clearPending(elementId);
      }
    });
  });

  // The sort section is collapsed whenever the drawer opens, except from the mobile « Trier par »
  // button, which opens the drawer on it. The click only records the intent: showDialog opens the
  // dialog on a later frame and then dispatches dialog:open, so the order of the click listeners
  // does not matter. dialog:open does not bubble, hence the capture listener.
  let openSortPanel = false;
  document.addEventListener(
    'click',
    (e) => {
      openSortPanel = e.target instanceof Element && e.target.closest('[data-opens-sort-panel]') !== null;
    },
    true
  );
  document.addEventListener(
    'dialog:open',
    (e) => {
      if (!(e.target instanceof Element) || e.target.id !== 'filters-drawer-alternate') return;
      const details = e.target.querySelector('[data-sort-details]');
      if (details instanceof HTMLDetailsElement) details.open = openSortPanel;
      openSortPanel = false;
    },
    true
  );

  // Quick filter pills + view-all CTA - soft-update via facets-form-component instead of full reload.
  // Document-level delegation survives section-renderer swaps.
  document.addEventListener('click', (e) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest('a.collection-alternate__filter-tag, a.collection-alternate__view-all-btn');
    if (!a) return;
    const inFilters = a.closest('.collection-alternate__filters-list');
    const isViewAll = a.classList.contains('collection-alternate__view-all-btn');
    if (!inFilters && !isViewAll) return;
    const form = document.querySelector('facets-form-component');
    if (!form || typeof form.updateFiltersByURL !== 'function') return;
    e.preventDefault();
    form.updateFiltersByURL(a.href);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-partners"] && !Shopify.designMode) return;
  try {
    
  class OurPartners extends HTMLElement {
    async connectedCallback() {
      this.list = this.querySelector('.our-partners__list');
      this.token = this.dataset.storefrontToken;
      this.namespace = this.dataset.metafieldNamespace || 'custom';
      this.key = this.dataset.metafieldKey || 'page_partenaires';

      if (!this.list || !this.token) return;

      try {
        const collections = await this.fetchPartnerCollections();
        this.renderList(collections);
      } catch (error) {
        if (window.console && console.error) {
          console.error('our-partners: failed to load partner collections', error);
        }
        // Fetch failed: clear the "loading" message instead of leaving it stuck
        // forever (mirrors the empty-result path in renderList).
        this.list.replaceChildren();
      }
    }

    async fetchPartnerCollections() {
      const endpoint = '/api/2026-10/graphql.json';
      const query =
        'query PartnerCollections($cursor: String) {' +
        '  collections(first: 250, after: $cursor) {' +
        '    pageInfo { hasNextPage endCursor }' +
        '    nodes { title handle metafield(namespace: "' +
        this.namespace +
        '", key: "' +
        this.key +
        '") { value } }' +
        '  }' +
        '}';

      const partners = [];
      let cursor = null;
      // Hard page cap so a misconfigured cursor can never loop forever.
      for (let page = 0; page < 60; page++) {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Shopify-Storefront-Access-Token': this.token,
          },
          body: JSON.stringify({ query, variables: { cursor } }),
        });
        if (!response.ok) throw new Error('Storefront ' + response.status);

        const json = await response.json();
        const connection = json && json.data && json.data.collections;
        if (!connection) throw new Error('Malformed Storefront response');

        for (const node of connection.nodes) {
          if (node.metafield && node.metafield.value === 'true') {
            partners.push({ title: this.decodeEntities(node.title), handle: node.handle });
          }
        }

        if (!connection.pageInfo.hasNextPage) break;
        cursor = connection.pageInfo.endCursor;
      }

      partners.sort((a, b) => a.title.localeCompare(b.title, 'fr', { sensitivity: 'base' }));
      return partners;
    }

    renderList(collections) {
      if (!collections.length) {
        this.list.replaceChildren();
        return;
      }
      const root =
        window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';
      const fragment = document.createDocumentFragment();
      for (const collection of collections) {
        const item = document.createElement('li');
        item.className = 'our-partners__item';
        const link = document.createElement('a');
        link.className = 'our-partners__link';
        link.href = root + 'collections/' + encodeURIComponent(collection.handle);
        // Titles are entity-decoded at fetch time; textContent keeps them injection-safe.
        link.textContent = collection.title;
        item.appendChild(link);
        fragment.appendChild(item);
      }
      this.list.replaceChildren(fragment);
    }

    // The Storefront API returns titles HTML-encoded (e.g. "Dolce &amp; Gabbana"),
    // so decode them once before sorting/rendering. A reused textarea decodes the
    // entities; the result is only ever assigned via textContent, so it stays safe.
    decodeEntities(value) {
      if (!this._decoder) this._decoder = document.createElement('textarea');
      this._decoder.innerHTML = String(value == null ? '' : value);
      return this._decoder.value;
    }
  }

  if (!customElements.get('our-partners')) {
    customElements.define('our-partners', OurPartners);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results-alternate"]) return;
  try {
    
  const toggle = document.querySelector('.search-alternate__view-toggle');
  if (toggle) {
    const grid = document.querySelector('.search-alternate__grid');
    toggle.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-view-columns]');
      if (!btn || !grid) return;
      const columns = btn.dataset.viewColumns;
      grid.dataset.view = columns;
      toggle.querySelectorAll('.search-alternate__view-btn').forEach((b) => {
        b.classList.toggle('search-alternate__view-btn--active', b === btn);
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
